export enum ContextTypes {
	WEB = 1,
  APP = 2
}

export enum BrandTypes {
	BOUVET = 1,
  MINCO = 2
}
